import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError, BRAND } from "@/lib/api";
import { RedButton } from "@/components/Layout";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("sa_token", data.token);
      nav("/admin");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-sared bg-[#0a0a0a] p-8">
        <img src={BRAND.logo} alt="SHRAL'AUTO" className="h-16 w-16 object-cover border border-sared" />
        <h1 className="mt-6 text-4xl text-white">Espace gestion</h1>
        <p className="mt-2 text-sm text-zinc-500">Accès réservé au garage.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <span className="font-mono-tech text-[10px] tracking-[0.2em] text-zinc-400 uppercase">E-mail</span>
            <input required type="email" data-testid="admin-email" value={form.email}
                   onChange={(e) => setForm({ ...form, email: e.target.value })}
                   className="mt-2 w-full bg-black border border-zinc-800 px-4 py-3 text-white focus:border-sared focus:outline-none" />
          </label>
          <label className="block">
            <span className="font-mono-tech text-[10px] tracking-[0.2em] text-zinc-400 uppercase">Mot de passe</span>
            <input required type="password" data-testid="admin-password" value={form.password}
                   onChange={(e) => setForm({ ...form, password: e.target.value })}
                   className="mt-2 w-full bg-black border border-zinc-800 px-4 py-3 text-white focus:border-sared focus:outline-none" />
          </label>
          <RedButton type="submit" disabled={busy} className="w-full" data-testid="admin-login-submit">
            {busy ? "Connexion..." : "Se connecter"}
          </RedButton>
        </form>
        <Link to="/" className="mt-6 block font-mono-tech text-[10px] tracking-[0.18em] text-zinc-600 hover:text-sared">
          ← RETOUR AU SITE
        </Link>
      </div>
    </div>
  );
}
